export const GET_REVENUE_CENTERS_REQUESTED = 'GET_REVENUE_CENTERS_REQUESTED'
export const GET_REVENUE_CENTERS_SUCCEEDED = 'GET_REVENUE_CENTERS_SUCCEEDED'
export const GET_REVENUE_CENTERS_FAILED = 'GET_REVENUE_CENTERS_FAILED'
